import { get, mapValues } from 'lodash';
import * as selectors from './composed';
import { STYLING_STATE_PATH } from '../reducers';

const mountSelector = selector => (state, ...rest) =>
  selector(get(state, STYLING_STATE_PATH), ...rest);

const mountedSelectors = mapValues(selectors, mountSelector);

export default mountedSelectors;
